import gql from 'graphql-tag'

export const reOrderPendingOrder = gql`
  query (
    $cart_id: String!,
    $pre_order_type: String,
    $customer_order_number: String,
    $type_of_transport: String,
    $ship_to: String
    $delivery_date: String,
  ) {
    reOrderPreOrder(
      cart_id: $cart_id,
      pre_order_type: $pre_order_type,
      customer_order_number: $customer_order_number,
      ship_to: $ship_to
      type_of_transport: $type_of_transport,
      delivery_date: $delivery_date,
    ) {
      message
      status
      failed_items {
        sku
        name
        quantity
      }
    }
  }
`
